import Alpine from 'alpinejs';

Alpine.data('profilePage', () => ({
    isSaving: false,
    showSuccessMessage: false,

    startSaving() {
        this.isSaving = true;
        this.showSuccessMessage = false;
    },

    handleEditFailed() {
        this.isSaving = false;
    },

    async handleEditSucceeded() {
        // Keep the modal in its saving state until the refreshed profile values are rendered.
        await this.$store.user.fetchUser();
        await this.$nextTick();

        this.$store.modals.close('profile-settings-modal');
        this.isSaving = false;
        this.showSuccessMessage = true;
    }
}));
